const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the Polls Manager Directive to display a list or table with events to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Events the resource defined to get and set Events data
 */
app.directive('navIcons', ['Application', function(Application) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        icon: "=?"
      },
      template: require('../../templates/directives/nav-icons.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.iconColor = Application.COLORS[0]
         
        }],
      controllerAs: 'icons'
    };
  }]);
